import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/logo.png'
import _imports_1 from '../../assets/images/img_01.png'
import _imports_2 from '../../assets/images/btn_googleplay.png'


const _withScopeId = n => (_pushScopeId("data-v-757a8f25"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"margin-top":"0px","height":"100%"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    alt: "Vue logo",
    src: _imports_0
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "",
  style: {"width":"450px","height":"200px"}
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://play.google.com/store/apps/details?id=com.hongrui.slots.gp" }, [
    /*#__PURE__*/_createElementVNode("img", {
      width: "210",
      height: "80",
      src: _imports_2
    })
  ])
], -1))
const _hoisted_6 = {
  class: "custom-slick-arrow",
  style: {"left":"10px","z-index":"1"}
}
const _hoisted_7 = {
  class: "custom-slick-arrow",
  style: {"right":"10px"}
}
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "https://www.trucomania.net/policy/policy.htm" }, "Policy", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_typography = _resolveComponent("a-typography")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_left_circle_outlined = _resolveComponent("left-circle-outlined")!
  const _component_right_circle_outlined = _resolveComponent("right-circle-outlined")!
  const _component_a_carousel = _resolveComponent("a-carousel")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout_footer = _resolveComponent("a-layout-footer")!
  const _component_a_layout = _resolveComponent("a-layout")!
  const _component_a_back_top = _resolveComponent("a-back-top")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_layout, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_layout_header, { style: { position: 'fixed', zIndex: 1, width: '100%' } }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_a_layout_content, {
            class: "content",
            style: { padding: '0 0px', marginTop: '64px', background:'#473C8B'}
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createVNode(_component_a_row, {
                justify: "center",
                style: {"margin-top":"5rem"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 6 }, {
                    default: _withCtx(() => [
                      _hoisted_4,
                      _createVNode(_component_a_typography, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_typography_title, { style: {"color":"white"} }, {
                            default: _withCtx(() => [
                              _createTextVNode("Introduction")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_typography_paragraph, { style: {"color":"white","padding":"0.5rem"} }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Este é um jogo on-line PK divertido e emocionante, simples de jogar e muito desafiador, especialmente para aqueles com um IQ alto, vêm e desafiam milhões de jogadores de todo o país, e muitos grandes prêmios a serem ganhos! Aqui você pode jogar: Blackjack, Texas Hold'em, Truco, Teenpatti, Deus da Riqueza, e muitos outros jogos para tornar seu tempo de inatividade mais divertido e agradável! ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_divider)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_typography, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_typography_title, { style: {"color":"white"} }, {
                            default: _withCtx(() => [
                              _createTextVNode("Jogo de Boas-Vindas")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_typography_paragraph, { style: {"color":"white"} }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Baixe agora e jogue ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_divider),
                          _hoisted_5
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_col, { span: 13 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_carousel, {
                        arrows: "",
                        autoplay: "",
                        effect: "fade",
                        "dot-position": _ctx.dotPosition
                      }, {
                        prevArrow: _withCtx(() => [
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_left_circle_outlined)
                          ])
                        ]),
                        nextArrow: _withCtx(() => [
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_right_circle_outlined)
                          ])
                        ]),
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imgs, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.key
                            }, [
                              _createElementVNode("img", {
                                src: item.src,
                                alt: "",
                                style: {"width":"1040px","height":"500px"}
                              }, null, 8, _hoisted_8)
                            ]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["dot-position"]),
                      _createVNode(_component_a_typography, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_typography_title, { style: {"color":"white"} }, {
                            default: _withCtx(() => [
                              _createTextVNode("Características")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_typography_paragraph, { style: {"color":"white"} }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 1: Pessoas reais jogando juntas online, onde você também pode fazer amigos! ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_typography_paragraph, { style: {"color":"white"} }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 2: Com os jogos de cartas mais populares, Texas Hold'em, Blackjack, Truco, Teenpatti ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_typography_paragraph, { style: {"color":"white"} }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 3: Jogos quentes e emocionantes: Slots, St. Patrick, Deus da Riqueza e etc.! Nota: Este jogo é apenas para entretenimento e diversão, não para jogar. Não há chance de ganhar dinheiro e o sucesso no jogo não significa que você também possa ter sucesso em um jogo de cassino real. ")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_divider)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_typography, { style: {"width":"1903px","height":"30px","text-align":"center"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_typography_paragraph, null, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_layout_footer, {
            style: _normalizeStyle([{"background-color":"#001529","height":"5rem","color":"white"}, { textAlign: 'center'}])
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Copyright © 2004-2022 Primate Labs Inc. ")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_a_back_top)
  ], 64))
}